enum LogisticsCompanyType {
    /** 直营 */
    DIRECT = "DIRECT",

    /** 加盟 */
    FRANCHISE = "FRANCHISE",

    /** 直营 + 加盟（直营带网点类型） */
    DIRECT_AND_FRANCHISE_MIXED = " DIRECT_AND_FRANCHISE_MIXED",

    /** 落地配 */
    LOCAL = "LOCAL",

    /** 既不是加盟，也不是直营，类型是『统采』，订购时无需填写网点，菜鸟统一分配网点。 */
    NEITHER_DIRECT_NOR_FRANCHISE = "NEITHER_DIRECT_NOR_FRANCHISE",
}

export default LogisticsCompanyType;
